import { Component } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.page.html',
  styleUrls: ['./banner.page.scss'],
})
export class BannerPage {
  public buttons = [
    {
      name: 'Carruseles del inicio',
      value: 'sliders',
    },
    {
      name: 'Banners de carruseles de productos',
      value: 'productsBanner',
    },
  ];

  public selected = 'sliders';
}
